const API_BASE_URL = '/api';

class TournamentAPI {
  getAuthHeaders() {
    const token = localStorage.getItem('auth_token');
    return token ? { 'Authorization': `Bearer ${token}` } : {};
  }
  async searchParticipants(query) {
    try {
      const response = await fetch(`${API_BASE_URL}/participants/search?q=${encodeURIComponent(query)}`, {
        headers: this.getAuthHeaders()
      });
      if (!response.ok) throw new Error('Failed to search participants');
      return await response.json();
    } catch (error) {
      console.error('Error searching participants:', error);
      return [];
    }
  }

  async getTournamentData() {
    try {
      const response = await fetch(`${API_BASE_URL}/tournaments/current`, {
        headers: this.getAuthHeaders()
      });
      if (!response.ok) throw new Error('Failed to get tournament data');
      return await response.json();
    } catch (error) {
      console.error('Error getting tournament data:', error);
      throw error;
    }
  }

  async addParticipant(name, weight) {
    try {
      const response = await fetch(`${API_BASE_URL}/tournaments/current/participants`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          ...this.getAuthHeaders()
        },
        body: JSON.stringify({ name, weight })
      });
      if (!response.ok) throw new Error('Failed to add participant');
      return await response.json();
    } catch (error) {
      console.error('Error adding participant:', error);
      throw error;
    }
  }

  async removeParticipant(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/tournaments/current/participants/${id}`, {
        method: 'DELETE',
        headers: this.getAuthHeaders()
      });
      if (!response.ok) throw new Error('Failed to remove participant');
      return await response.json();
    } catch (error) {
      console.error('Error removing participant:', error);
      throw error;
    }
  }

  async clearTournament() {
    try {
      const response = await fetch(`${API_BASE_URL}/tournaments/current`, {
        method: 'DELETE',
        headers: this.getAuthHeaders()
      });
      if (!response.ok) throw new Error('Failed to clear tournament');
      return await response.json();
    } catch (error) {
      console.error('Error clearing tournament:', error);
      throw error;
    }
  }

  async updateSettings(settings) {
    try {
      const response = await fetch(`${API_BASE_URL}/tournaments/current/settings`, {
        method: 'PUT',
        headers: { 
          'Content-Type': 'application/json',
          ...this.getAuthHeaders()
        },
        body: JSON.stringify(settings)
      });
      if (!response.ok) throw new Error('Failed to update settings');
      return await response.json();
    } catch (error) {
      console.error('Error updating settings:', error);
      throw error;
    }
  }

  async getAllParticipants() {
    try {
      const response = await fetch(`${API_BASE_URL}/participants`, {
        headers: this.getAuthHeaders()
      });
      if (!response.ok) throw new Error('Failed to get all participants');
      return await response.json();
    } catch (error) {
      console.error('Error getting all participants:', error);
      return [];
    }
  }

  async deleteParticipant(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/participants/${id}`, {
        method: 'DELETE',
        headers: this.getAuthHeaders()
      });
      if (!response.ok) throw new Error('Failed to delete participant');
      return await response.json();
    } catch (error) {
      console.error('Error deleting participant:', error);
      throw error;
    }
  }

  async createNewTournament(settings) {
    try {
      const response = await fetch(`${API_BASE_URL}/tournaments/new`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          ...this.getAuthHeaders()
        },
        body: JSON.stringify({ settings })
      });
      if (!response.ok) throw new Error('Failed to create tournament');
      return await response.json();
    } catch (error) {
      console.error('Error creating tournament:', error);
      throw error;
    }
  }
}

export default new TournamentAPI();